var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStructureOfTheGame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "F\\xFCllung",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475.31,388.69l-64-64a16,16,0,0,0-22.62,22.62L425.37,384H174a63.73,63.73,0,0,0-7-16.75L367.25,167A64,64,0,1,0,338,96H174a64,64,0,1,0,0,32H338a63.57,63.57,0,0,0,6.7,16.22L144.22,344.73A64,64,0,1,0,174,416h251.4l-36.68,36.69a16,16,0,1,0,22.62,22.62l64-64A16,16,0,0,0,475.31,388.69ZM400,80a32,32,0,1,1-32,32A32,32,0,0,1,400,80ZM112,144a32,32,0,1,1,32-32A32,32,0,0,1,112,144Zm0,288a32,32,0,1,1,32-32A32,32,0,0,1,112,432Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStructureOfTheGame);
export default __webpack_public_path__ + "static/media/icon-structure-of-the-game.5e7c1cd4.svg";
export { ForwardRef as ReactComponent };